import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import Approach from "../components/Approach";
import Calculator from "../components/Calculator";
import Programs from "../components/Programs";
import SamplePlan from "../components/SamplePlan";
import Transformations from "../components/Transformations";
import Testimonials from "../components/Testimonials";
import InstagramShowcase from "../components/InstagramShowcase";
import GallerySection from "../components/GallerySection";
import ArticlesTeaser from "../components/ArticlesTeaser";
import Faq from "../components/Faq";
import IntakeForm from "../components/IntakeForm";
import Footer from "../components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div id="top" className="relative min-h-screen bg-ink text-white overflow-x-clip">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Approach />
        <Calculator />
        <Programs />
        <SamplePlan />
        <Transformations />
        <Testimonials />
        <InstagramShowcase />
        <GallerySection />
        <ArticlesTeaser />
        <Faq />
        <IntakeForm />
      </main>
      <Footer />
    </div>
  );
}